import React from "react";
import OfferPage from "../components/OfferPage";

const OfferWorkshop = () => (
  <OfferPage
    ns="offerWorkshop"
    page="workshop"
    path="/offers/workshop"
    order={["formats", "whatItIs", "gets", "aiAct", "faq"]}
  />
);

export default OfferWorkshop;
